import React from "react";
import { zhFAQ } from "./faq.js";
import { Link } from "./en.js";
const introText = (
  <>
    中国全球电力（CGP）数据库追踪中国通过外国直接投资（FDI）和/或由中国进出口银行（CHEXIM）和中国国家开发银行（CDB）这两家中国开发性金融机构（DFIs）所投资的海外发电厂。
    <br />
    <br />
    2000-2023年，中国开发性金融机构及投资者融资支持745座海外发电厂，融资范围覆盖96个国家/地区，涵盖1542个发电机组，发电装机容量达177吉瓦。在这些发电厂中，中国参与资本形式包括绿地投资、并购（M&A）为主的外国直接投资及开发性金融机构债务融资。
  </>
);
const aboutText = (
  <div>
    <p>
      中国全球电力（CGP）数据库追踪中国通过外国直接投资（FDI）和/或中国进出口银行（CHEXIM）和中国国家开发银行（CDB）这两家中国开发性金融机构（DFIs）所投资的海外发电厂。该数据库记载并显示交易类型、中国投资者和/或贷款方、投资者所有权百分比、发电装机容量（兆瓦）、技术类型、运营状态、融资及投产年份，以及中国海外投资发电厂预计产生的二氧化碳年排放量。
    </p>
    <p>
      中国全球电力数据库由波士顿大学全球发展政策研究中心（GDP中心）管理。波士顿大学全球发展政策研究中心是波士顿大学的校级研究中心，与佛雷德里克•帕迪（Frederick
      S.
      Pardee）全球研究学院紧密合作。波士顿大学全球发展政策研究中心致力于推动政策导向型研究，以促进金融稳定、人类福祉和环境可持续性。
    </p>
    <p>
      中国国家开发银行和中国进出口银行官方目前尚未系统地发布这些数据。过去几年来，波士顿大学全球发展政策研究中心制定了一套数据追踪方法，来填补该数据空白。
    </p>
    <p style={{ fontWeight: "bold" }}>联系我们：</p>
    <p>
      有关数据库的技术咨询或建议，请联系Diego Morro，邮箱:
      <Link href="mailto:dm3760@bu.edu">dm3760@bu.edu</Link>。
    </p>
    <p>
      有关媒体咨询，请联系Sam Igo，邮箱:
      <Link href="mailto:sigo@bu.edu">sigo@bu.edu</Link>。
    </p>
    <p>数据库于2025年5月更新。</p>
    <p style={{ fontWeight: "bold" }}>建议引用: </p>
    <p>
      Boston University Global Development Policy Center. 2025. China’s Global
      Power Database. Retrieved from{" "}
      <a href="https://www.bu.edu/cgp/">https://www.bu.edu/cgp/</a>
    </p>
    <p style={{ fontWeight: "bold" }}>资源：</p>
    <p>
      关于2025年中国全球电力数据库数据更新方法的信息，请参阅
      <Link href="https://www.bu.edu/gdp/2021/03/23/gdp-center-database-methodology-guidebook/">
        《GDP中心数据库使用方法指南》
      </Link>
      和
      <Link href="https://www.bu.edu/gdp-cn/2025/04/28/%e7%a0%94%e7%a9%b6%e9%80%9f%e9%80%92%ef%bd%9c%e5%81%9c%e6%ad%a2%e6%96%b0%e5%bb%ba%e7%85%a4%e7%94%b5%e9%a1%b9%e7%9b%ae%ef%bc%9a%e4%b8%ad%e5%9b%bd%e6%b5%b7%e5%a4%96%e7%94%b5%e5%8e%82%e6%8a%95%e8%b5%84/">
        2025年政策简报
      </Link>
      附录。关于中国全球电力数据库（2020年）首次迭代的数据和方法信息请参阅
      <Link href="https://www.bu.edu/gdp/2020/10/19/chinas-global-power-database-methodology-note/">
        2020年使用方法注记
      </Link>
      。
    </p>
    <p>有关研究和政策评论，请参阅：</p>
    <ul>
      <li>
        <Link href="https://www.bu.edu/gdp-cn/2025/04/28/%e7%a0%94%e7%a9%b6%e9%80%9f%e9%80%92%ef%bd%9c%e5%81%9c%e6%ad%a2%e6%96%b0%e5%bb%ba%e7%85%a4%e7%94%b5%e9%a1%b9%e7%9b%ae%ef%bc%9a%e4%b8%ad%e5%9b%bd%e6%b5%b7%e5%a4%96%e7%94%b5%e5%8e%82%e6%8a%95%e8%b5%84/">
          2025年政策简报
        </Link>
      </li>
      <li>
        <Link href="https://www.bu.edu/gdp-cn/2022/10/31/%e7%a0%94%e7%a9%b6%e9%80%9f%e9%80%92%ef%bd%9c%e4%ba%86%e8%a7%a3%e4%b8%ad%e5%9b%bd%e6%b5%b7%e5%a4%96%e7%94%b5%e5%8a%9b%ef%bc%9a2022%e5%b9%b4%e6%9b%b4%e6%96%b0/">
          2022年政策简报
        </Link>
      </li>

      <li>
        <Link href="https://www.bu.edu/gdp/2020/10/19/chinas-global-power-database-policy-brief/">
          2020年政策简报
        </Link>
      </li>
      <li>
        <Link href="https://www.bu.edu/gdp/2020/10/23/chinas-global-power-estimating-chinese-foreign-direct-investment-in-the-electric-power-sector-2/">
          2020年《能源政策》期刊文章
        </Link>
      </li>
      <li>
        <Link href="https://www.bu.edu/gdp/2020/10/08/chinese-overseas-development-financing-of-electric-power-generation-a-comparative-analysis/">
          2020年《一个地球》期刊文章
        </Link>
      </li>
      <li>
        <Link href="https://www.bu.edu/gdp/2018/10/02/energizing-development-finance-the-benefits-risks-of-chinas-development-finance-in-the-global-energy-sector/">
          2018年《能源政策》期刊文章
        </Link>
      </li>
    </ul>
    <p style={{ fontWeight: "bold" }}>致谢：</p>
    <p>
      波士顿大学全球发展政策研究中心感谢Zhongshu Li、Xu Chen和Xinyue
      Ma对该数据库的基础研究。GDP中心还感谢普林斯顿大学土木与环境工程系和公共与国际事务学院的Denise
      L.Mauzerall教授参与了促成该项目的一些学术论文。我们也非常感谢Thang
      Ha、Shengheng Li、 Jingjing Li和Victoria Bien
      Aime的研究帮助。最后，GDP中心要感谢查尔斯•斯图尔特•莫特基金会、
      欧洲气候基金会、休利特基金会和洛克菲勒兄弟基金会的资金支持，让此项研究和交互数据库得以呈现。
    </p>
    <p>
      中国全球电力数据库由
      <Link href="https://pitchinteractive.com/">Pitch Interactive</Link>创建。
    </p>
    <p style={{ fontWeight: "bold" }}>数据下载：</p>
    <p>要下载数据，请填写并提交以下表格：</p>
  </div>
);
const multiAttributeCopy = (
  <span>
    选择一个或多个感兴趣的国家和地区，生成描述所选国家和地区有中国资本参与的电站2018底的投产状态、能源类型分布及到2030年二氧化碳年排放量估计的图表。
  </span>
);

export const zhObj = {
  // general
  "China’s Global Power Database": "中国全球电力数据库",
  "China’s Foreign Direct Investment and Development Finance in Power Generation Overseas":
    "中国电力部门的对外直接投资与开发性融资",
  "About / Data Download": "关于/数据下载",
  Overview: "概览",
  "Multi-Attribute Comparison": "比较视图",
  multiAttributeCopy,
  "Choose a Modifier": "选择比较单位",
  "Choose up to 9": "最多可选择9个国家",
  "Generate Report": "生成报告",
  "Modify Report": "修改报告",
  "Export PDF": "导出PDF",
  "POWER GENERATION CAPACITY AND ESTIMATED ANNUAL CO2 EMISSIONS WITH CHINESE CAPITAL BY 2033":
    "截至2033年中国资本参与的海外电站装机容量和CO₂年排放量估算",
  "Capacity (MW) by Status 2000-2030": "2000-2030年 装机容量及投产状态分布",
  "Capacity (MW) by Technology": "装机容量及能源类型分布",
  "CO2 Emissions (K Ton) by Technology": "各能源类型年均CO2排放估算（千吨）",
  "Estimated Annual Emissions from Power Generation with Chinese Capital":
    "中国资本参与的海外电站CO2年排放量估算",
  GLOBAL: "全球",
  Year: "年份",
  "Commission Year": "投产年份",
  "Expand All": "显示全部",
  "Collapse All": "折叠全部",
  "Change Timeframe": "修改时间范围",
  Timeframe: "电站投产时间范围",
  "Select All": "选择全部",
  "Deselect All": "取消全选",
  Cancel: "取消全选",
  Apply: "应用",
  "Funding Year": "融资年份",
  "M&A Year": "合并与收购年份",
  "Prior Owner": "前所有者",
  ASIA: "亚洲",
  EUROPE: "欧洲",
  Close: "关闭",
  "Plant Name": "电站名称",
  Capacity: "装机容量",
  "Capacity (MW)": "装机容量（MW）",
  Status: "项目状态",
  "Project Status": "项目状态",
  "Year of Commission": "投产年份",
  Technology: "能源类型",
  State: "州/省",
  Countries: "国家",
  Country: "国家",
  Regions: "地区",
  Region: "地区",
  "View in Table": "查看表格",
  "CO2 Emissions": "年度CO2排放量",
  Emissions: "排放量",
  "Estimated Annual CO2 Emissions from Power Generation (1000 ton)":
    "CO2年排放估算（千吨）",
  "Deal Type": "交易类型",
  "FDI?": "对外直接投资参与?",
  FDI: "对外直接投资参与",
  DFI: "开行/口行参与",
  "Investing Company": "投资公司",
  "Investing Country Ownership %": "投资公司所有权%",
  "FDI Deal Type": "FDI交易类型",
  "Involving Chinese DFI?": "中国DFI参与?",
  "Involving Chinese Policy Bank?": "中国政策性银行参与?",
  Lender: "贷款方",
  Borrower: "借款方",
  Source: "来源",
  "In Operation": "运营中",
  "Under Construction": "建设中",
  "Under Planning": "计划中",
  Pending: "待定",
  Wind: "风电",
  Coal: "煤电",
  Hydropower: "水电",
  Solar: "太阳能",
  Gas: "天然气",
  Biomass: "生物质能",
  Oil: "燃油",
  Nuclear: "核能",
  Geothermal: "地热能",
  SPAIN: "西班牙",
  PORTUGAL: "葡萄牙",
  ETHIOPIA: "埃塞俄比亚",
  INDONESIA: "印度尼西亚",
  TOGO: "多哥",
  "UNITED KINGDOM": "英国",
  BRAZIL: "巴西",
  MEXICO: "墨西哥",
  BANGLADESH: "孟加拉国",
  MALAYSIA: "马来西亚",
  INDIA: "印度",
  UZBEKISTAN: "乌兹别克斯坦",
  "BURKINA FASO": "布基纳法索",
  MADAGASCAR: "马达加斯加",
  "CZECH REPUBLIC": "捷克",
  "COTE D'IVOIRE": "科特迪瓦",
  CROATIA: "克罗地亚",
  "DEMOCRATIC REPUBLIC OF CONGO": "刚果民主共和国",
  "DOMINICAN REPUBLIC": "多米尼加共和国",
  ECUADOR: "厄瓜多尔",
  "EQUATORIAL GUINEA": "赤道几内亚",
  JAPAN: "日本",
  ITALY: "意大利",
  CHILE: "智利",
  COLOMBIA: "哥伦比亚",
  "REPUBLIC OF KOREA": "韩国",
  TURKEY: "土耳其",
  JORDAN: "约旦",
  PAKISTAN: "巴基斯坦",
  IRELAND: "爱尔兰",
  CANADA: "加拿大",
  GAMBIA: "冈比亚",
  "UNITED STATES": "美国",
  BELARUS: "白俄罗斯",
  CAMEROON: "喀麦隆",
  KYRGYZSTAN: "吉尔吉斯斯坦",
  NEPAL: "尼泊尔",
  "SAUDI ARABIA": "沙特阿拉伯",
  GHANA: "加纳",
  "CONGO DEM REP": "刚果（金）",
  "CONGO, DEM. REP.": "刚果（金）",
  ARGENTINA: "阿根廷",
  AUSTRALIA: "澳大利亚",
  VIETNAM: "越南",
  ZAMBIA: "赞比亚",
  GEORGIA: "格鲁吉亚",
  BULGARIA: "保加利亚",
  MYANMAR: "缅甸",
  "SOUTH AFRICA": "南非",
  MALTA: "马耳他",
  CHAD: "乍得",
  ROMANIA: "罗马尼亚",
  UKRAINE: "乌克兰",
  TAJIKISTAN: "塔吉克斯坦",
  "PAPUA NEW GUINEA": "巴布亚新几内亚",
  KAZAKHSTAN: "哈萨克斯坦",
  SUDAN: "苏丹",
  BELGIUM: "比利时",
  KENYA: "肯尼亚",
  NIGERIA: "尼日利亚",
  MALI: "马里",
  GABON: "加蓬",
  FRANCE: "法国",
  "SRI LANKA": "斯里兰卡",
  "UNITED ARAB EMIRATES": "阿联酋",
  MALDIVES: "马尔代夫",
  ZIMBABWE: "津巴布韦",
  POLAND: "波兰",
  CONGO: "刚果（布）",
  UGANDA: "乌干达",
  MOROCCO: "摩洛哥",
  CUBA: "古巴",
  GUINEA: "几内亚",
  CAMBODIA: "柬埔寨",
  MALAWI: "马拉维",
  SERBIA: "塞尔维亚",
  THAILAND: "泰国",
  NETHERLANDS: "荷兰",
  PHILIPPINES: "菲律宾",
  SWEDEN: "瑞典",
  GERMANY: "德国",
  MONTENEGRO: "黑山",
  FIJI: "斐济",
  LAOS: "老挝",
  "SOUTH SUDAN": "南苏丹",
  EGYPT: "埃及",
  BOLIVIA: "玻利维亚",
  PERU: "秘鲁",
  "BOSNIA AND HERZEGOVINA": "波斯尼亚和黑塞哥维那",
  "NEW ZEALAND": "新西兰",
  SINGAPORE: "新加坡",
  HUNGARY: "匈牙利",
  RUSSIA: "俄罗斯",
  "EUROPE/CENTRAL ASIA": "欧洲/中亚",
  AFRICA: "非洲",
  "SOUTHEAST ASIA": "东南亚",
  LAC: "拉美及加勒比",
  "SOUTH ASIA": "南亚",
  "EAST ASIA": "东亚",
  "MIDDLE EAST": "中东",
  "NORTH AMERICA": "北美",
  OCEANIA: "大洋洲",
  Greenfield: "绿地投资",
  "M&A": "并购",
  "DFI only": "开行/口行",
  "FDI + DFI": "FDI + 开行/口行",
  "Policy bank only": "政策性银行融资",
  "FDI + Policy bank": "FDI + 政策性银行",
  Yes: "是",
  No: "否",
  NA: "NA",
  "Ex-Im Bank": "中国进出口银行",
  CDB: "CDB",
  "CDB-Ex-Im Cofinancing": "开行口行联合融资",
  // companies
  "Beijing Jingneng & PowerChina": "京能集团",
  "Canadian Solar": "阿特斯",
  CETIC: "中国电力技术进出口公司",
  ChemChina: "中国化工",
  "CHINA COMMUNICATION CONSTRUCTION CO LTD": "中国交建",
  "China Datang": "大唐集团",
  "China General Nuclear Power Group": "中广核",
  "China General Technology": "通用技术集团",
  "China Gezhouba": "葛洲坝集团",
  "China Huadian Corporation": "中国华电",
  "China Huaneng Group": "中国华能",
  "China International Trust & Investment Corp - CITIC": "中信集团",
  "China Investment Corp": "中投公司",
  "China Metallurgical Group Corporation": "中冶集团",
  "China National Building Material": "中国建材",
  "China National Electrical Engineering Corporation": "中国电工",
  "China National Machinery Industry Corporation": "国机集团",
  "China National Offshore Oil Corporation": "中海油",
  "China National Petroleum Corporation": "中石油",
  "CHINA POWER INVESTMENT CORP": "中电国际",
  "China Southern Power Grid": "南方电网",
  "CHINA SUNERGY CO": "中电光伏",
  "China Three Gorges Corporation": "（中国）三峡集团",
  Chinaerdos: "鄂尔多斯集团",
  Chint: "正泰集团",
  "CLENERGY (XIAMEN) TECH CO LTD": "清源科技",
  "CLP Holdings": "中电控股",
  "Datang International Power Generation": "大唐发电",
  "Envision Energy": "远景集团",
  "ET SOLAR": "建开阳光",
  "Fuxing Xiaocheng": "福星晓程",
  "Guodian Group": "国电集团",
  "HANERGY GROUP CO LTD": "汉能集团",
  "Harbin Electric": "哈电集团",
  "Hareon Solar": "海润光伏",
  "JIANGSU ZHENFA HOLDINGS": "振发新能",
  "Jinko Solar": "晶科能源",
  "JINKOSOLAR HOLDING CO LTD": "晶科能源",
  "LDK Solar": "赛维集团",
  "Metallurgical Corporation of China": "中冶集团",
  "Panda Green Energy Group": "能猫绿能",
  PowerChina: "中国电建",
  ReneSola: "瑞能集团",
  "RISEN ENERGY CO LTD": "东方日升",
  "SHANGHAI ELECTRIC GROUP": "上海电气",
  "Shenhua Group": "中国神华",
  "Shenzhen Energy Corporation": "深圳能源",
  "Shenzhen Nanshan Power Co": "深南电",
  "Shunfeng Investment Limited": "顺风光电",
  Sinopec: "中石化",
  "State Development and Investment": "国投",
  "State Grid Corporation of China": "国家电网",
  "State Power Investment Corporation": "国家电投",
  Suntech: "尚德电力",
  "Trina Solar": "天合光能",
  "Union Resources & Engineering Corporation": "云南能投",
  "XIANGTAN ELECTRIC MANUFACTURE CORP": "湘电集团",
  "Xinjiang Goldwind Science & Technology (Goldwind)": "金风科技",
  "Zhefu Holdings": "浙富控股",
  "ZHEJIANG KAISHAN COMPRESSOR CO": "开山集团",
  "Zhenfa New Energy": "振发新能",
  ZTE: "中兴通讯",
  //
  ALL: "全部年份",
  Explore: "探索",
  FAQ: "常见问题与解答",
  Language: "语言",
  "Ownership %": "所有权比重%",
  "Click to Lock Project": "点击锁定项目",
  "Click to Unlock Project": "点击解除锁定",
  "K Ton": "千吨",
  Government: "政府",
  Share: "分享",
  Project: "项目",
  Total: "总计",
  "Cumulative Total": "累计总计",
  // new
  "by Status": "及投产状态分布",
  "by Technology": "及能源类型分布",
  // jsx or long
  introText,
  aboutText,
  faqText: zhFAQ,
  ANGOLA: "安哥拉",
  "BRUNEI DARUSSALAM": "文莱",
  ERITREA: "厄立特里亚",
  IRAN: "伊朗",
  IRAQ: "伊拉克",
  "KYRGYZ REPUBLIC": "吉尔吉斯斯坦",
  LESOTHO: "莱索托",
  LIBERIA: "利比里亚",
  MONGOLIA: "蒙古",
  "REPUBLIC OF CONGO": "刚果共和国",
  "RUSSIAN FEDERATION": "俄罗斯",
  RWANDA: "卢旺达",
  "SOUTH KOREA": "韩国",
  TUNISIA: "突尼斯",
  "UNITED STATES OF AMERICA": "美国",
  Waste: "废弃物",
  AMERICAS: "美洲",
  "State/Province": "州/省",
  Annual: "年度",

  "Coal, Gas": "煤电, 天然气",
  "Gas, Oil": "天然气, 燃油",
  "In Operation, Under Construction": "运营中, 建设中",
  "Under Construction, Under Planning": "建设中, 计划中",
  "In Operation, Under Planning": "运营中, 计划中",
  Plants: "发电厂",
  "Multiple values": "这个电站有多个电机组和特点。",
};
